import type { PassEnhancedDataPayload } from '../../../../store/types/pass';
import type { AppleEnhancedDesignFeaturedActions } from '../../../../store/types/template';
import { buildFeaturedActionsPayload } from '../../pass-templates-new/utils/formatTemplatePayload';
import { featuredActionsEqual } from '../../pass-templates-new/utils/featuredActionTypes';

interface BuildPassEnhancedDataPayloadParams {
  featuredActions: AppleEnhancedDesignFeaturedActions;
  storedFeaturedActions: AppleEnhancedDesignFeaturedActions;
  isCreate?: boolean;
  isEnhancedGeneric: boolean;
}

export const buildPassEnhancedDataPayload = ({
  featuredActions,
  storedFeaturedActions,
  isCreate,
  isEnhancedGeneric,
}: BuildPassEnhancedDataPayloadParams): PassEnhancedDataPayload | undefined => {
  if (!isEnhancedGeneric) return undefined;
  if (!isCreate && featuredActionsEqual(featuredActions, storedFeaturedActions))
    return undefined;

  return {
    generic: { featuredActions: buildFeaturedActionsPayload(featuredActions) },
  };
};
